<template>
    <div class="maintanence-area">
        <div class="wrapper">
            <div class="row row--0 h-100">
                <div class="col-lg-4 col-md-4">
                    <div class="inner">
                        <div class="logo logo-custom-css">
                            <router-link class="logo-light" to="/">
                                <img :src="require(`@/assets/sentrys-logo-sm.png`)" alt="nft-logo" width="40">
                                <span class="logo-text">Sentrys.io</span>
                            </router-link>
                            <router-link class="logo-dark" to="/">
                                <img :src="require(`@/assets/sentrys-logo-sm.png`)" alt="nft-logo" width="40">
                            </router-link>
                        </div>
                        <div class="content">
                            <span class="sub-title">Stay Tuned</span>
                            <h3 class="title">
                                <span>Coming Soon</span>
                            </h3>
                            <p>
                               Our website is under construction, we are working very hard to give you the best experience.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-8 col-md-8">
                    <carousel class="banner-one-slick comeing-soon-slick slider-style-4 slick-activation-09 slick-arrow-style-one rn-slick-dot-style"
                              :items-to-show="1"
                              :wrap-around="true">
                        <slide v-for="(carouselItem, index) in carouselItems" :key="index">
                            <div :class="`w-100 single-rn-slider ${carouselItem.image} bg_image`"/>
                        </slide>
                    </carousel>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Carousel, Slide} from 'vue3-carousel'

    export default {
        name: 'ComingSoon',
        components: {Carousel, Slide},
        data() {
            return {
                carouselItems: [
                    {image: 'bg_image--14'},
                ]
            }
        }
    }
</script>